import { FaWhatsapp, FaPhone, FaFacebook, FaInstagram, FaXTwitter, FaYoutube } from "react-icons/fa6";
import "./css/Contact.css";

export default function Contact() {
  return (
    <div className="contact-page">
      <h1 className="contact-heading">Contact Us</h1>

      <div className="map-container">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3925.2132752358616!2d76.32388089999999!3d10.3248098!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba7fb08b3bc44a5%3A0x300569ddfbac7bc7!2sAVP%20Production!5e0!3m2!1sen!2sin!4v1761577849695!5m2!1sen!2sin"
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>

      <div className="contact-buttons">
        <a href="https://wa.me/916238764086" target="_blank" rel="noopener noreferrer" className="whatsapp-btn">
          <FaWhatsapp /> WhatsApp Us
        </a>
        <a href="tel:+916238764086" className="call-btn">
          <FaPhone /> Call Us
        </a>
      </div>

      <div className="contact-info">
        <p>
          Email:{" "}
          <a href="mailto:admin@avpproduction.com" className="email-link">
            admin@avpproduction.com
          </a>
        </p>
        <p>Address: AVP Production, Opposite Indian Petrol Station, Potta, Chalakudy. Thrissur</p>
        <a href="https://nihalansar.me" target="_blank" rel="noopener noreferrer" >Made with ☕ <span className="by-text">By Nihal</span></a>
      </div>

      <div className="social-icons">
        <a href="https://www.facebook.com/share/19rs5HYRMY/?mibextid=wwXIfr" target="_blank" rel="noopener noreferrer"><FaFacebook /></a>
        <a href="https://www.instagram.com/avpproductionofficial?igsh=MTh0a2ljdzdtaHVxYQ==" target="_blank" rel="noopener noreferrer"><FaInstagram /></a>
        <a href="#" rel="noopener noreferrer"><FaXTwitter /></a>
        <a href="#" rel="noopener noreferrer"><FaYoutube /></a>
      </div>
    </div>
  );
}